// @flow
import * as React from "react"
import fp from "lodash/fp"
import TextLink from "@kiwicom/orbit-components/lib/TextLink"
import Text from "@kiwicom/orbit-components/lib/Text"
import styled from "styled-components"
import type { ThemeProps } from "@kiwicom/nitro/lib/records/Theme"

import Translate from "../../../../../../app/scripts/components/Translate"

const Link = styled.a`
  color: ${({ theme }: ThemeProps) => theme.orbit.colorTextPrimary};
  text-decoration: underline;
`

type Props = {
  _error?: boolean,
  handleSelectingCorrected: () => void,
  active?: boolean,
  activeNoteEl?: ?React.Element<*>,
  alwaysShowNoteEl?: ?boolean,
  corrector: ?(string) => string,
  corrected?: string,
  error?: ?(string | Object), // eslint-disable-line flowtype/no-weak-types
  suppressErrorNote: ?boolean,
  value: string,
  typo?: boolean,
  onCloseTypo?: () => void,
}

export const getCorrected = (corrected: ?string, value: string, corrector: ?(string) => string) => {
  if (corrected) {
    return corrected
  }
  return corrector ? corrector(value) : ""
}

const TextFieldNote = ({
  _error,
  handleSelectingCorrected,
  active,
  activeNoteEl,
  alwaysShowNoteEl,
  corrector,
  corrected,
  error,
  suppressErrorNote,
  value,
  typo,
  onCloseTypo,
}: Props) => {
  // Sorting of conditions is important !
  // ===

  const correctedNote = getCorrected(corrected, value, corrector)

  if (correctedNote) {
    return (
      <div className="spField-corrector">
        <Translate
          dynamic
          tKey="common.did_you_mean"
          values={{
            x: <a onClick={handleSelectingCorrected}>{correctedNote}</a>, // eslint-disable-line
          }}
        />
      </div>
    )
  }

  if (typo) {
    return (
      <Text type="secondary" element="p" size="small">
        <Translate tKey="booking.passenger.typo_info" />{" "}
        {/* FIX ME - +27.3.2019 - https://skypicker.slack.com/archives/CAMS40F7B/p1552913713014900 - Pls delete only <Link> */}
        <Link>
          <TextLink onClick={onCloseTypo} type="primary" size="small">
            <Translate tKey="booking.passenger.typo_correct" />
          </TextLink>
        </Link>
      </Text>
    )
  }

  // Error is rendered only in case of (touched && error && !active)
  // Object means we want to translate dynamic
  if (_error && !suppressErrorNote) {
    if (typeof error === "object" && fp.isObject(error)) {
      return <Translate {...error} dynamic />
    }
    if (error === "required") {
      return <Translate tKey="forms.this_field_must_be_filled" />
    }
    return <Translate tKey={error} />
  }

  // When active (or always with alwaysShowNoteEl exception) maybe show special active (hint) note above field
  if (activeNoteEl && (active || alwaysShowNoteEl)) {
    return activeNoteEl
  }

  return null
}

TextFieldNote.defaultProps = {
  corrected: "",
}

export default TextFieldNote
